export const ERRORS = {
    ERROR_401: 'ERROR_401',
    ERROR_500: 'ERROR_500',
    ERROR_BIZ: 'ERROR_BIZ',
};

// antd组件尺寸
export const ANTD_COMPONENT_SIZE = {
    1: 'small',
    2: 'middle',
    3: 'large',
}

//导航栏
export const MENU_CODE_NAV = "site_nav"
//首页
export const MENU_CODE_PAGE1 = "page1"
//生态与合作
export const ECO_SYSTEM = "ecosystem"
//AI语音
export const VOICE_AI = "VoiceAI"
//api价格
export const API_PRICING = "pricing"
//开发者plan
export const SUBSCRIPTION_PLAN = "subscription-plan"
//关于#about
export const ABOUT = "about"
